// extracted by mini-css-extract-plugin
export default {"DaySlots":"DaySlots_DaySlots__sfjPy"};